import GetRoomsRequestModel from '../../../generated/types/model/request/GetRoomsRequestModel';

export default class GetRoomsRequestViewModel extends GetRoomsRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
